module.exports = __webpack_public_path__ + "static/assets/12a8e2ea264048fb05a4471f44a5c34e.svg";